import {
  UserProfileUpdatePudDocument,
  UserProfileUpdatePudMutationVariables,
} from "@graphql/api";

interface Variables {
  creditCard: be.CreditCard | be.TokenizedCreditCard;
  location: be.Pud;
}

export default async function userProfileUpdatePud(
  { creditCard, location }: Variables,
): Promise<boolean> {
  const client = global.window.apolloClient;

  if (!location.id) {
    throw new Error("Location ID is required for updating PUD");
  }

  const mutVars: UserProfileUpdatePudMutationVariables = {
    pudId: parseInt(location.id),
    location: {
      code: location.code ?? "",
      address: location.address,
      addressDetails: location.addressDetails,
      city: location.city,
      crossStreet: location.crossStreet,
      displayAddress: location.displayAddress,
      displayName: location.displayName,
      directions: location.directions,
      state: location.state,
      zip: location.zip,
      name: location.name,
      sector: location.sector,
      county: location.county,
      country: location.country,
      latLng: location.latLng?.lat ? { lat: location.latLng.lat, lng: location.latLng.lng } : undefined,
      googlePlaceId: location.googlePlaceId,
      type: location.type,
      pudName: location.pudName,
      locationType: location.locationType,
      email: location.email,
      telephone: location.telephone,
      telephone2: location.telephone2,
      faxNumber: location.faxNumber,
    },
  };
  
  // Only add credit card if it's a new card (not tokenized)
  // Check that it's not a tokenized card by verifying it doesn't have a token field
  if (creditCard && !('token' in creditCard) && 'number' in creditCard && creditCard.number) {
    mutVars.location.creditCard = {
      number: creditCard.number,
      expiration: creditCard.expiration ?? "",
      name: creditCard.name ?? "",
      address: creditCard.address,
      postalCode: creditCard.postalCode,
    };
  }

  const result = await client.mutate({
    mutation: UserProfileUpdatePudDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileUpdatePud?.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileUpdatePud?.success ?? false;
}
